import { Brand, createBranded } from '@deltasierra/type-utilities';
import { FileName, SanitizedFileName, getFileNameFromPath } from '@deltasierra/utilities-upload';
export { isImageMimeType } from '@deltasierra/utilities-web-image';

export { FileName, SanitizedFileName, getFileNameFromPath };

export type Base64Data = Brand<string, 'Base64Data'>;
export const Base64Data = createBranded<Base64Data>();

export type DataUri = Brand<string, 'DataUri'>;
export const DataUri = createBranded<DataUri>();

export type FilePath = Brand<string, 'FilePath'>;
export const FilePath = createBranded<FilePath>();

export type RelativeFilePath = Brand<string, 'RelativeFilePath'>;
export const RelativeFilePath = createBranded<RelativeFilePath>();

export type FileExtensionWithoutDot = Brand<string, 'FileExtensionWithoutDot'>;
export const FileExtensionWithoutDot = createBranded<FileExtensionWithoutDot>();

export function getFileNameExcludingExtension(filenameOrPath: FileName | string): FileExtensionWithoutDot {
    return FileExtensionWithoutDot.from(filenameOrPath.substring(0, filenameOrPath.lastIndexOf('.')) || filenameOrPath);
}

export function getFileExtension(filenameOrPath: FileName | string): FileExtensionWithoutDot {
    return FileExtensionWithoutDot.from(filenameOrPath.split('.').pop()?.trim() ?? '');
}

export function updateFileExtension(
    filenameOrPath: FileName | string,
    newExtensionsWithoutDot: string,
): FileName | string {
    return `${filenameOrPath.substr(0, filenameOrPath.lastIndexOf('.'))}.${newExtensionsWithoutDot}`;
}

export interface BlobWithData extends Blob {
    lastModified?: number;
    name?: string;
}

export type FileOrBlob = BlobWithData | File;
